import { stampAndAppendTracePoint } from './tracePointHelpers.js';
export function startExecution(state, initialWorkflow, mutableWorkflow, nodeName) {
    if (!mutableWorkflow.stepsByThreadIndex?.[0]?.length) {
        throw new Error(`[${nodeName}] invariant violated: thread 0 has no steps`);
    }
    const event = {
        tracePointKind: 'workflow_start',
        workflowHandle: initialWorkflow.handle,
        workflow: initialWorkflow,
    };
    return {
        mutableWorkflow,
        startEmitted: true,
        ...stampAndAppendTracePoint(state, 0, event),
    };
}
export function endExecution(state, nodeName) {
    if (!state.mutableWorkflow) {
        throw new Error(`[${nodeName}] mutableWorkflow not set in graph state`);
    }
    if (!Array.isArray(state.mutableWorkflow.stepsByThreadIndex)) {
        throw new Error(`[${nodeName}] invariant violated: mutableWorkflow.stepsByThreadIndex must be an array`);
    }
    const threadIndices = state.mutableWorkflow.stepsByThreadIndex
        .map((_steps, index) => index).sort((a, b) => a - b);
    const canonicalThreadIndex = threadIndices[0];
    if (canonicalThreadIndex === undefined) {
        throw new Error(`[${nodeName}] workflow has no threads`);
    }
    const currentThreadIndex = state.currentThreadIndex;
    const hasThread = currentThreadIndex !== undefined && currentThreadIndex !== null;
    const nextThreadEndMap = hasThread
        ? { ...(state.threadEndMap ?? {}), [currentThreadIndex]: true }
        : state.threadEndMap ?? {};
    if (!state.endEmitted && Object.keys(nextThreadEndMap).length >= threadIndices.length) {
        const event = {
            tracePointKind: 'workflow_end',
            workflowHandle: state.mutableWorkflow.handle,
        };
        return {
            ...(hasThread ? { threadEndMap: { [currentThreadIndex]: true } } : {}),
            endEmitted: true,
            ...stampAndAppendTracePoint(state, canonicalThreadIndex, event),
            currentThreadIndex: null,
        };
    }
    return hasThread ? { threadEndMap: { [currentThreadIndex]: true } } : {};
}
